import { ProfessionalTypeEnum } from '@gql/graphql';
import { Button, InputLabel, InputSelect, InputWrapper } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import { FiMapPin, FiSearch } from 'react-icons/fi';
import type { ProLandingPageProps } from '..';
import { ProRadioInput } from './ProRadioInput';

export const ProSearchForm: FC<ProLandingPageProps> = (props) => {
  const { proSearch } = props;
  const { translate } = useTranslation();

  const placeholderSearch = useMemo(() => {
    if (proSearch.values.proType === ProfessionalTypeEnum.VET) {
      return translate('common.inputs.searchNameService.placeholder');
    }

    return translate('common.inputs.searchKeyName.placeholder');
  }, [proSearch.values.proType, translate]);

  const labelSearch = useMemo(() => {
    if (proSearch.values.proType === ProfessionalTypeEnum.VET) {
      return translate('common.inputs.searchNameService.label');
    }

    return translate('common.inputs.searchKeyName.label');
  }, [proSearch.values.proType, translate]);

  return (
    <>
      <ProRadioInput proSearch={proSearch} />
      <InputWrapper>
        <InputLabel icon={<FiSearch />}>{labelSearch}</InputLabel>
        <InputSelect<number>
          loading={proSearch.loading}
          placeholder={placeholderSearch}
          value={proSearch.tempValues.search ?? proSearch.values.search}
          search={proSearch.inputValues.search}
          selectOptions={proSearch.options.search}
          onSearchChange={(search) => {
            proSearch.fieldChangeHandler({ type: 'search', value: search });
          }}
          onSelect={(selected) => {
            proSearch.fieldSelectHandler({ type: 'search', value: selected });
          }}
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel icon={<FiMapPin />}>{translate('common.inputs.where.placeholder')}</InputLabel>
        <InputSelect<string>
          value={proSearch.tempValues.location ?? proSearch.values.location}
          search={proSearch.inputValues.location}
          selectOptions={proSearch.options.location}
          onSearchChange={(search) => {
            proSearch.fieldChangeHandler({ type: 'location', value: search });
          }}
          onSelect={(selected) => {
            proSearch.fieldSelectHandler({ type: 'location', value: selected });
          }}
        />
      </InputWrapper>
      <Button size="large" color="blue" type="submit" onClick={proSearch.submit}>
        {translate('common.buttons.search')}
      </Button>
    </>
  );
};
